'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSchema(_ref) {
  var view = _ref.page.view,
      _ref$config = _ref.config,
      models = _ref$config.models,
      views = _ref$config.views;

  // use schema in view
  if (views[view] && views[view].schema) return views[view].schema;

  // use schema in model
  var modelName = views[view] && views[view].model || view;
  var model = models[modelName];

  console.assert(model, 'can not find model schema of \'' + view + '\'');

  return model.schema;
}

function getUiSetting(_ref2) {
  var view = _ref2.page.view,
      _ref2$config = _ref2.config,
      models = _ref2$config.models,
      views = _ref2$config.views;

  if (views[view] && views[view].ui) return views[view].ui;
  return models[view].ui;
}

var shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  config: object.isRequired
}), (0, _injectProps2.default)({
  page: shape({
    view: string.isRequired
  })
}), (0, _exposeProps2.default)(function (props) {
  return {
    schema: getSchema(props),
    uiSetting: getUiSetting(props)
  };
}));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'provideSetting');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/connectServer/provideSetting.js
// module id = 1121
// module chunks = 0